var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex-box is-vertical"},[_c('div',{ref:"chart",style:(_vm.chartStyle)})])}
var staticRenderFns = []

export { render, staticRenderFns }